import { render, staticRenderFns } from "./purchaseInvoices.vue?vue&type=template&id=67c0ad70&scoped=true&"
import script from "./purchaseInvoices.vue?vue&type=script&lang=js&"
export * from "./purchaseInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0ad70",
  null
  
)

export default component.exports